<template>
  <ElForm label-position="right">
    <ElFormItem :label="$t('APP.RELEASES.MAIN_OBB')">
      <ObbSelector
        :value="attachedMainObb"
        :upload-url="mainObbUploadPath"
        :files="mainObbFiles"
        @change="handleMainObbSelect"
      />
    </ElFormItem>

    <ElFormItem
      v-if="Number.isInteger(attachedMainObb)"
      :label="$t('APP.RELEASES.PATCH_OBB')"
    >
      <ObbSelector
        :value="attachedPatchObb"
        :upload-url="patchObbUploadPath"
        :files="patchObbFiles"
        @change="handlePatchObbSelect"
      />
    </ElFormItem>

    <div v-show="errorMessage" class="text-alert">
      <i class="el-icon-warning" />
      {{ errorMessage }}
    </div>
  </ElForm>
</template>

<script>
import ObbSelector from './ObbSelector';

export default {
  name: 'PackageExpansionsManagerUI',
  components: { ObbSelector },

  props: {
    mainObbFiles: {
      type: Array,
      default: () => [],
    },
    patchObbFiles: {
      type: Array,
      default: () => [],
    },
    attachedMainObb: {
      type: Number,
      default: null,
    },
    attachedPatchObb: {
      type: Number,
      default: null,
    },
    mainObbUploadPath: {
      type: String,
      required: true,
    },
    patchObbUploadPath: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },

  methods: {
    handleMainObbSelect(mainObbId) {
      this.error = null;

      if (Number.isInteger(mainObbId)) {
        this.attachObb(mainObbId);
      } else if (Number.isInteger(this.attachedMainObb)) {
        this.detachObb(this.attachedMainObb);
      }
    },

    handlePatchObbSelect(patchObbId) {
      this.error = null;

      if (Number.isInteger(patchObbId)) {
        this.attachObb(patchObbId);
      } else if (Number.isInteger(this.attachedPatchObb)) {
        this.detachObb(this.attachedPatchObb);
      }
    },

    detachObb(obbId) {
      this.$emit('detach', obbId);
    },

    attachObb(ObbId) {
      this.$emit('change', ObbId);
    },
  },
};
</script>
